import React from 'react'

const Footer = ({ language }) => (
  <div id="footer">
    <div className="container small-container">
      <p>
        <a href="https://bestofjs.org">Best of JavaScript</a> is a project created by{' '}
        <a href="https://michaelrambeau.com/">Michael Rambeau</a>, from Osaka,
        Japan.
      </p>
    </div>
  </div>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js